import { gql } from '@apollo/client'

export const GOAL_SHARED_TO_FUNDER_CARD = gql`
  query goalSharedToFunderCard(
    $activeOnly: Boolean
    $goalId: Int
    $funderOrgId: Int!
  ) {
    goalSharedToFunderCard(
      activeOnly: $activeOnly
      goalId: $goalId
      funderOrgId: $funderOrgId
    ) {
      nonprofitOrgId
      category
      isComplete
      ChecklistItem {
        createdAt
        goalId
        dueDate
        id
        isCompleted
        linkText
        linkUrl
        resourceId
        title
        updatedAt
      }
      EntryGroup {
        id
      }
      description
      endDate
      id
      title
      startDate
      target
      targetProgress
      impactCategory
    }
  }
`
